module.exports = __webpack_public_path__ + "static/screenshot4-ea52d4b81454cbe1535137cc4c6fba16.png";